/**
 * @package   ScandiPWA\GtmGraphQl
 * @author    Abdelrahman Hady <abdelrahman.hady@scandiweb.com>
 * @copyright Copyright (c) 2023 Scandiweb, Inc (https://scandiweb.com)
 * @license   http://opensource.org/licenses/OSL-3.0 The Open Software License 3.0 (OSL-3.0)
 */

import Event, { EVENT_GTM_ADD_PAYMENT_INFO_GA4 } from '../../../util/Event';
import BaseEventEvent from './BaseEvent.event';

export const CHECKOUT_EVENT_DELAY = 1100;
export const SPAM_PROTECTION_DELAY = 1000;

/**
 * After filling payment info
 *
 * @namespace Gtm/Component/GoogleTagManager/GA4_events/AddPaymentInfo/Event */
export class AddPaymentInfoEvent extends BaseEventEvent {
    /**
     * Event fire delay
     *
     * @type {number}
     */
    eventHandleDelay = CHECKOUT_EVENT_DELAY;

    /**
     * Bind
     */
    bindEvent() {
        Event.observer(EVENT_GTM_ADD_PAYMENT_INFO_GA4, ({ payment_type }) => {
            this.handle(payment_type);
        });
    }

    /**
     * Handle
     */
    handler(payment_type) {
        if (this.spamProtection(SPAM_PROTECTION_DELAY)) {
            return;
        }

        this.pushEventData({
            currency: this.getCurrencyCode(),
            value: this.getItemsTotal(),
            payment_type,
            items: this.getCartItemsWithListData()
        });
    }
}

export default AddPaymentInfoEvent;
